<template>
    <main>
        <section class="hero tw-pt-4">
            <div class="lg:tw-container tw-flex tw-flex-col lg:tw-flex-row lg:tw-gap-1 xl:tw-gap-10 lg:tw-justify-between lg:tw-items-start tw-items-center">
                <div class="info-container">
                    <h1>Poupe tempo e dinheiro <br class="tw-hidden lg:tw-block !xl:tw-hidden"> na sua empresa</h1>
                    <h2 class="cards-info tw-hidden lg:tw-block">O Cartão PRIO, oferece-lhe inúmeras vantagens:</h2>
                    <div class="cards-info tw-hidden lg:tw-flex lg:tw-items-center xl:tw-gap-4 lg:tw-gap-0 tw-w-full">
                        <div>
                            <ul>
                                <li>Garantia de preço mais baixo</li>
                                <li>Pagamentos rápidos e seguros via app PRIO.GO</li>
                                <li>Gestão online dos consumos e cartões</li>
                                <li>Opção de pagamento a crédito ou <br>pré-pagamento</li>
                                <li>Ampla rede de postos aderentes</li>
                                <li>Sem custos nem fidelização</li>
                            </ul>
                        </div>
                        <div>
                            <img src="~@/assets/img/cards.png">
                        </div>
                    </div>
                </div>
                <div class="form-container">
                    <div class="title">
                        <span v-if="!$store.state.formSuccess && $store.state.formStep <= 2">Simular poupança</span>
                        <span v-if="!$store.state.formSuccess && $store.state.formStep > 2">Simular poupança</span>
                        <span v-if="$store.state.formSuccess">Simular poupança</span>
                    </div>
                    <Form v-if="!$store.state.formSuccess" />
                    <FormSuccess v-if="$store.state.formSuccess" />
                </div>
                <div class="mobile-list tw-block lg:tw-hidden">
                    <div class="tw-container">
                        <div class="cards-info tw-flex tw-flex-col lg:tw-hidden tw-gap-4 tw-w-full">
                            <div>
                                <h2 class="cards-info tw-block lg:tw-hidden">O Cartão Prio, oferece-lhe inúmeras vantagens:</h2>
                                <ul>
                                    <li>Garantia de preço mais baixo</li>
                                    <li>Pagamentos rápidos e seguros via app PRIO.GO</li>
                                    <li>Gestão online dos consumos e cartões</li>
                                    <li>Opção de pagamento a crédito ou <br>pré-pagamento</li>
                                    <li>Ampla rede de postos aderentes</li>
                                    <li>Sem custos nem fidelização</li>
                                </ul>
                            </div>
                            <div>
                                <img src="~@/assets/img/cards.png">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="info">
            <div class="tw-container">
                <h2>MAIS DE 20.000 EMPRESAS JÁ ADERIRAM!</h2>
                <h3>Adira já, sem custos ou fidelização! Oferta garantida do <span>preço mais competitivo</span>.</h3>
                <div class="tw-grid tw-grid-cols-1 lg:tw-grid-cols-3 tw-gap-4 lg:tw-gap-8">
                    <div>
                        <img src="~@/assets/img/icons/info-check.svg">
                        <p>Nenhum cartão frota em Portugal oferece tantas vantagens a uma empresa</p>
                    </div>
                    <div>
                        <img src="~@/assets/img/icons/info-check.svg">
                        <p>Pensado para otimizar a gestão de frota e contabilidade organizada para as empresas</p>
                    </div>
                    <div>
                        <img src="~@/assets/img/icons/info-check.svg">
                        <p>Com atendimento personalizado e gestores disponíveis para o ajudar</p>
                    </div>
                </div>
                <button class="btn-page tw-mx-auto tw-block tw-mt-6" v-scroll-to="'.title'">Simular Poupança</button>
            </div>
        </section>
    </main>
</template>
<script>
import Form from '@/components/Form.vue';
import FormSuccess from '@/components/FormSuccess.vue';

export default {
    name: 'Home',
    components: {
        Form,
        FormSuccess,
    },
};
</script>
